<div class="page">
<ng-container *ngIf="!statsService.editingStats">
    <h2>Stats</h2>
    <p><label class="fixed-size">Authors Helped:</label> <strong>{{statsService.authorsHelped}}</strong></p>
    <p><label class="fixed-size">Books Sold:</label> <strong>{{statsService.booksSold}}</strong></p>
    <p><label class="fixed-size">Titles Published:</label> <strong>{{statsService.titlesPublished}}</strong></p>
    <p><label class="fixed-size">Years Experience:</label> <strong>{{statsService.yearsExperience}}</strong></p>

    <button class="primary-button" type="add" (click)="this.editStat()">Edit Stats</button>
</ng-container>
<ng-container *ngIf="statsService.editingStats">
    <h2>Editing: Stats</h2>
    <br>
    <form [formGroup]="statForm">
        <label class="fixed-size" for="authorsHelped">Authors Helped: </label>
        <input id="authorsHelped" type="number" formControlName="authorsHelped">
        <br>
        <label class="fixed-size" for="booksSold">Books Sold: </label>
        <input id="booksSold" type="number" formControlName="booksSold">
        <br>
        <label class="fixed-size" for="titlesPublished">Titles Published: </label>
        <input id="titlesPublished" type="number" formControlName="titlesPublished">
        <br>
        <label class="fixed-size" for="yearsExperience">Years Experience: </label>
        <input id="yearsExperience" type="number" formControlName="yearsExperience">
        <br>

      </form>
      <form [formGroup]="statForm" (ngSubmit)="submitStatEdits()"></form>
      <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
      <button class="primary-button" type="submit" [disabled]="!statForm.valid" (click)="this.submitStatEdits()">Submit</button>
</ng-container>
</div>